import { filterBar } from './filter-bar';
import { foreignRecords } from './foreign_records';

export const views = ($http: HttpApi) => ({
  // nested resources
  foreignRecords: foreignRecords($http),
  filterBar: filterBar($http),
});
